
<div *ngIf="typeContent == 'espacios'">
  <div *ngIf="contentData[typeContent][positions]">
    <div [innerHTML]="contentData[typeContent][positions].html | domSeguro"></div>
  </div>
</div>
